export const IntranetLayers = {
    People: 'people',
    Groups: 'groups',
} as const;
export type IntranetLayer = (typeof IntranetLayers)[keyof typeof IntranetLayers];

export const ExactMatchParams: Record<IntranetLayer, string> = {
    [IntranetLayers.People]: 's_login',
    [IntranetLayers.Groups]: 's_url',
} as const;

export interface IntranetLayerParams {
    page?: number;
    perPage?: number;
    language?: string;
    query?: string;
    exactMatch?: string[];
}

export type IntranetLayersParams = {
    [layer in IntranetLayer]?: IntranetLayerParams;
};

export interface IntranetLayerResultBase {
    id?: string;
    layer?: string;
    title: string;
    url?: string;
    click_urls?: string[];
}

export interface IntranetLayerResult {
    [IntranetLayers.People]: {
        affiliation?: string;
        is_dismissed?: boolean;
        is_memorial?: boolean;
        is_robot?: boolean;
        login: string;
        phone?: any;
        telegram?: any;
        name: {
            first: string;
            last: string;
            middle?: string;
        };
        position?: string;
        department_name?: string;
        gaps?: any[];
        gap?: any;
        cars?: any[];
        bicycles?: any[];
        staff_agreement?: boolean;
        staff_id?: number;
        uid?: string;
    };
    [IntranetLayers.Groups]: {
        affiliation_counters: {[key: string]: number};
        department: string | null;
        department_id: number | null;
        service: string | null;
        service_id: number | null;
        slug: string;
        type: string;
    };
}

export type IntranetSuggestResponse = {
    [layer in IntranetLayer]?: {
        result?: (IntranetLayerResult[layer] & IntranetLayerResultBase)[];
        pagination?: {
            page: number;
            per_page: number;
            pages: number;
            count: number;
        };
    };
};
